import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
// import 'react-fastclick';

import { GatewayProvider, GatewayDest } from 'react-gateway';
import WrapperHeadroom from '../../components/wrapper-headroom';
import MessageRoot from '../../containers/message-root';
import DemoMessageRoot from '../../containers/demo-message-root';
import ModalRoot from '../../containers/modal-root';
import AccessibilityListener from '../accessibility-listener';
import styles from './app.scss';

export class AppMobile extends Component {
  scrollable = null;

  setScrollable = node => {
    this.scrollable = node;
  };

  renderOutsideScroll() {
    const { headroomHeader, stickyHeader, menu } = this.props;

    if (headroomHeader) {
      const header = React.cloneElement(headroomHeader, { menu });
      return (
        <WrapperHeadroom menu={menu}>
          {header}
        </WrapperHeadroom>
      );
    }
    if (stickyHeader) {
      return React.cloneElement(stickyHeader, { menu });
    }

    return null;
  }

  renderInsideScroll() {
    const { simpleHeader, menu } = this.props;
    let header = null;

    if (simpleHeader) {
      header = React.cloneElement(simpleHeader, { menu });
    }
    return header;
  }

  getOutsideScrollHeaderSize() {
    const { headroomHeader, categories, menu } = this.props;
    if (headroomHeader) {
      return 50 + (categories.length > 1 && menu ? 50 : 0);
    }
    return 0;
  }

  getHeaderClass() {
    const headerSize = this.getOutsideScrollHeaderSize();
    return {
      'no-gap': headerSize === 0,
      'medium-gap': headerSize === 50,
      'large-gap': headerSize === 100,
    };
  }

  ///start patch for ios safari scroll down bug (app is not responsive if scroll on top 0 and the user pulls down the browser)
  handleSafariTouchStart = event => {
    if (this.scrollable) {
      this.allowUp = this.scrollable.scrollTop > 0;
      this.allowDown = this.scrollable.scrollTop < this.scrollable.scrollHeight - this.scrollable.clientHeight;
      this.slideBeginY = event.changedTouches[0].pageY;
    }
  };

  isEditableOnFocus() {
    return (
      (document.activeElement.tagName === 'DIV' && document.activeElement.getAttribute('contenteditable') === 'true') ||
      document.activeElement.tagName === 'TEXTAREA' ||
      document.activeElement.tagName === 'INPUT'
    );
  }

  handleSafariTouchMove = event => {
    if (this.scrollable) {
      const up = event.changedTouches[0].pageY > this.slideBeginY;
      const down = event.changedTouches[0].pageY < this.slideBeginY;
      this.slideBeginY = event.changedTouches[0].pageY;
      if ((up && this.allowUp) || (down && this.allowDown)) {
        event.stopPropagation();
      } else if (!this.isEditableOnFocus()) {
        event.preventDefault();
      }
    }
  };

  ///end patch for ios safari

  /// start fast active - allow setting css when user taps on an element => need to add '.active' css rule to elements that you want to change
  clearActive() {
    if (this.activeElement && this.activeElement.classList) {
      this.activeElement.classList.remove('active');
      this.activeElement = null;
    }
  }

  setActive(e) {
    this.clearActive();
    if (this.activeElement && this.activeElement.classList) {
      this.activeElement = e.target;
      this.activeElement.classList.add('active');
    }
  }

  componentDidMount() {
    if ('ontouchstart' in window || (window.DocumentTouch && window.document instanceof window.DocumentTouch)) {
      window.document.body.addEventListener('touchstart', this.setActive.bind(this), false);
      window.document.body.addEventListener('touchmove', this.clearActive.bind(this), false);
    }
  }
  /// end fast active - allow setting css when user taps on an element => need to add '.active' css rule to elements that you want to change

  renderScroll() {
    const { main, overlay, children } = this.props;
    return (
      <div
        ref={this.setScrollable}
        className={classNames(styles.scrollable, 'app-mobile__scrollable')}
        onTouchStart={this.handleSafariTouchStart}
        onTouchMove={this.handleSafariTouchMove}
      >
        {overlay}
        {this.renderInsideScroll()}
        {React.cloneElement(main, { children })}
      </div>
    );
  }

  render() {
    return (
      <GatewayProvider>
        <div className={classNames(styles.app, this.getHeaderClass(), 'app-mobile', 'forum-background-color')}>
          <AccessibilityListener/>
          <MessageRoot/>
          <DemoMessageRoot/>
          {this.renderOutsideScroll()}
          {this.renderScroll()}
          <GatewayDest name="footer"/>
          <ModalRoot/>
          <GatewayDest name="floating-action-button"/>
          <GatewayDest name="tooltip"/>
        </div>
      </GatewayProvider>
    );
  }
}

AppMobile.propTypes = {
  children: PropTypes.node,
  simpleHeader: PropTypes.node,
  stickyHeader: PropTypes.node,
  headroomHeader: PropTypes.node,
  main: PropTypes.node,
  menu: PropTypes.node,
  categories: PropTypes.array,
  overlay: PropTypes.node,
};

const mapStateToProps = state => ({
  categories: state.categories,
});

export default connect(mapStateToProps)(AppMobile);



// WEBPACK FOOTER //
// ./app/components/app/app-mobile.js